<div class="flex row justify-center try-block">
    <div class="flex row content">
        <div class="flex column align-center feature-block">
            <h1>Try FrogEye for free</h1>
            <div>
                <button mat-flat-button (click)="login()">Get Started</button>
                &nbsp;
                <button mat-stroked-button routerLink="/contact">Contact Us</button>
            </div>
        </div>
    </div>
</div>
